import drawIndividualConfetti from './drawIndividualConfetti';
import { ROTATION_RANGE, SPEED_RANGE, SPRITE_HEIGHT, SPRITE_WIDTH } from './constants';

type IndividualConfettiParams = {
  confettiAmount: number;
  width: number;
  yRange: number;
  colors: string[];
};

export type IndividualConfetti = {
  initX: number;
  initY: number;
  rotation: number;
  speed: number;
  canvas: HTMLCanvasElement;
};

const buildSprites = ({
  confettiAmount,
  width,
  yRange,
  colors,
}: IndividualConfettiParams): IndividualConfetti[] => {
  const sprites = [];
  for (let i = 0; i < confettiAmount; ++i) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const initX = Math.random() * width;
    const initY = -canvas.height - Math.random() * yRange;
    const rotation = ROTATION_RANGE / 2 - Math.random() * ROTATION_RANGE;
    const speed = SPEED_RANGE / 2 + Math.random() * (SPEED_RANGE / 2);

    canvas.width = SPRITE_WIDTH;
    canvas.height = SPRITE_HEIGHT;
    drawIndividualConfetti({ ctx, canvas, colors });

    sprites.push({ initX, initY, rotation, speed, canvas });
  }
  return sprites;
};

export default buildSprites;
